export default __webpack_public_path__ + "static/media/img_baseCottonBunnyEars_cotton_p.7a4947cd.jpg";